var _defs, _path, _line, _polyline, _polyline2, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBasketSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "basket",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#c8a26d;stroke-miterlimit:10;stroke-width:1.92px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.23,20.6H6.77a2.87,2.87,0,0,1-2.84-2.4L2.42,9.1H21.58l-1.51,9.1A2.87,2.87,0,0,1,17.23,20.6Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 9.1,
    x2: 0.5,
    y2: 9.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.21 11.02 7.21 9.1 10.08 2.4"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.79 11.02 16.79 9.1 13.92 2.4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 12.94,
    x2: 12,
    y2: 17.73
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.17,
    y1: 12.94,
    x2: 8.17,
    y2: 17.73
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    y1: 12.94,
    x2: 15.83,
    y2: 17.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasketSvgrepoCom);
export default __webpack_public_path__ + "static/media/shopping-basket-svgrepo-com.e00b2c3e3209ba2a6df61ce1eb531b21.svg";
export { ForwardRef as ReactComponent };